module.exports = __webpack_public_path__ + "static/media/p5_s4.85e1c54f.ogg";